import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import * as React from 'react';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Collapse,
    Divider,
    Grid,
    Dialog,
    DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField
} from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People'
import LocalDiningIcon from '@material-ui/icons/LocalDining'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ReportsIcon from '@material-ui/icons/Assessment'
import MotorcycleIcon from '@material-ui/icons/Motorcycle'
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import {inject, observer} from 'mobx-react';
import {observable, action} from 'mobx';
import LocalLogStore from "../logging/LocalLogStore";
import moment from "moment";

export interface INavigationDrawerItemsProps extends RouteComponentProps<any> {
    loggingStore?: LocalLogStore
}

@inject("loggingStore")
@observer
class NavigationDrawerItems extends React.Component<INavigationDrawerItemsProps>{

    @observable private reportsOpen: boolean = false;
    @observable private logsDialogOpen: boolean = false;
    @observable private logContent: string = "";

    @action
    private handleReportSection = () => {
        this.reportsOpen = !this.reportsOpen;
    }

    private handleLogs = () => {
        let tempStr: string = "";
        this.props.loggingStore.logMessages.forEach(record => {
            tempStr += moment(record.messageDate).format("DD.MM.YYYY HH:mm:ss-SSS") + " ";
            tempStr += record.message + "\n"
        });
        this.logContent = tempStr;
        this.logsDialogOpen = true;
    }

    @action
    private handleDialClose = name=> event => {
        this[name] = !this[name];
        this.logContent = "";
    }

    public render() {
        return (
            <div>
            <List style={{width: 300}}>
                <Link to="/clients">
                    <ListItem button>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Klienti" />
                    </ListItem>
                </Link>
                <Link to="/orders">
                    <ListItem button>
                        <ListItemIcon>
                            <ShoppingCartIcon />
                        </ListItemIcon>
                        <ListItemText primary="Objednávky" />
                    </ListItem>
                </Link>
                <Link to="/web-orders">
                    <ListItem button>
                        <ListItemIcon>
                            <ShoppingCartIcon />
                        </ListItemIcon>
                        <ListItemText primary="Webové objednávky" />
                    </ListItem>
                </Link>
                <ListItem button onClick={this.handleReportSection}>
                    <ListItemIcon>
                        <ReportsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Reporty" />
                </ListItem>
                <Collapse in={this.reportsOpen} timeout="auto" unmountOnExit>
                    <List disablePadding>
                        <Link to="/report/mealsToMake">
                            <ListItem button style={{paddingLeft: '30px'}}>
                                <ListItemIcon>
                                    <LocalDiningIcon />
                                </ListItemIcon>
                                <ListItemText primary="Plánovaná jídla" />
                            </ListItem>
                        </Link>
                        <Link to="/report/deliveryPlan">
                            <ListItem button style={{paddingLeft: '30px'}}>
                                <ListItemIcon>
                                    <MotorcycleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Rozvovový plán" />
                            </ListItem>
                        </Link>
                        <Link to="/report/smartEmailing">
                            <ListItem button style={{paddingLeft: '30px'}}>
                                <ListItemIcon>
                                    <MailOutlineIcon />
                                </ListItemIcon>
                                <ListItemText primary="SmartEmailing" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Divider />
                <List style={{width: 300}}>
                    <ListItem button onClick={this.handleLogs}>
                        <ListItemText primary="Logy" />
                    </ListItem>
                </List>
            </List>
            <Dialog
                fullWidth={true}
                maxWidth="lg"
                open={this.logsDialogOpen}
                onClose={this.handleDialClose('logsDialogOpen')}
                aria-labelledby="delete-confirm-dialog">
                <DialogTitle id="delete-confirm-dialog">Logy</DialogTitle>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <TextField multiline value={this.logContent} style={{minWidth: '600px'}}
                                       fullWidth />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleDialClose('logsDialogOpen')} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            </div>
        )
    }
}

export default withRouter(NavigationDrawerItems);



// WEBPACK FOOTER //
// ./src/components/NavigationDrawerItems.tsx